// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wysiwyg_wrapper__O_wq6","wrapper--focused":"wysiwyg_wrapper--focused__QEXJA","wrapper--invalid":"wysiwyg_wrapper--invalid__ythgP"};